'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddController = function () {
  function AddController(CouponsDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AddController);
    this.CouponsDataProvider = CouponsDataProvider;
    this.$state = $state;
  }

  (0, _createClass3.default)(AddController, [{
    key: 'create',
    value: function create(form) {
      if (!form) {
        return false;
      }
      var vm = this;
      vm.CouponsDataProvider.createCoupon(vm.coupon).then(function (res) {
        if (res.exist == '1') {
          vm.existRecord = 1;
        } else {
          vm.$state.go('app.couponlisting');
        }
      });
    }
  }]);
  return AddController;
}();

// WEBPACK FOOTER //


exports.default = AddController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/components/add/controller.js
 **/